<app-base-send-queue
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [pageTitle]="pageTitle"
  [showReseller]="true"
  [isShowOrganizationSearch]="true"
  pageId="app-users-send-queue"
  [pageTagName]="tagName"
  [tabName]="tabName"
>
</app-base-send-queue>
